/** In-flight custom search (ADVANCED_SEARCH) HTTP cancellation. */

let activeController = null

export function abortAdvancedSearchIfRunning() {
  if (activeController) {
    activeController.abort()
    activeController = null
  }
}

export function createAdvancedSearchAbortSignal() {
  abortAdvancedSearchIfRunning()
  activeController = new AbortController()
  return activeController.signal
}

export function clearAdvancedSearchAbortController() {
  activeController = null
}
